import React, { useState, useCallback, useMemo, useContext } from 'react';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const TimeFilter = ({ defaultValue, handleClose, onApply, search, onChange, slug, externalOptions = {} }) => {
  const { t } = useContext(ConfigContext);

  const timeOptions = (externalOptions[slug] || []).map(({ id, value }) => ({ value: id, label: value }));
  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search ? timeOptions.filter(({ label }) => label.toLowerCase().includes(search.toLowerCase())) : timeOptions,
    [timeOptions, search]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout name={t(slug)} handleClose={handleClose} onApply={() => onApply(values)} hideLayout={!!search}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            name={`${slug}-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default TimeFilter;
